import { Action } from '@ngrx/store';


export enum AdmCamposCActionTypes {
  GET_ADM_CAMPOSC = '[ADM_CARTO] GetCamposC',
  SUCESS_CAMPOSC = '[ADM_CARTO] SuccessCamposC',
  FAIL_CAMPOSC = '[ADM_CARTO] FailCamposC',
}

export class AdmGetCamposC implements Action {
  readonly type = AdmCamposCActionTypes.GET_ADM_CAMPOSC;
  constructor(public url: string) {}
}

export class AdmSuscessCamposC implements Action {
  readonly type = AdmCamposCActionTypes.SUCESS_CAMPOSC;
  constructor(public Respuesta: any) {}
}

export class AdmFailCamposC implements Action {
  readonly type = AdmCamposCActionTypes.FAIL_CAMPOSC;
  constructor(public Respuesta: any) {}
}


export type AdmCamposCAcciones =
    | AdmGetCamposC
    | AdmSuscessCamposC
    | AdmFailCamposC;
